import { useState } from 'react';
import { Link } from 'react-router-dom';
import MotionScene from '../MotionScene';

const base = import.meta.env.BASE_URL;

type Tool = { name: string; src: string };

const BUSINESS: Tool[] = [
  { name: 'WhatsApp', src: `${base}logos/whatsapp.svg` },
  { name: 'Gmail', src: `${base}logos/gmail.svg` },
  { name: 'Google Sheets', src: `${base}logos/googlesheets.svg` },
  { name: 'Google Calendar', src: `${base}logos/googlecalendar.svg` },
  { name: 'Slack', src: `${base}logos/slack.svg` },
  { name: 'HubSpot', src: `${base}logos/hubspot.svg` },
  { name: 'Notion', src: `${base}logos/notion.svg` },
  { name: 'Xero', src: `${base}logos/xero.svg` },
  { name: 'Stripe', src: `${base}logos/stripe.svg` },
  { name: 'Airtable', src: `${base}logos/airtable.svg` },
];

const AUTOMATION: Tool[] = [
  { name: 'n8n', src: `${base}logos/n8n-logo.png` },
  { name: 'Make', src: `${base}logos/make-logo.png` },
  { name: 'Zapier', src: `${base}logos/zapier-logo.png` },
];

const ToolsStrip = () => {
  const [paused, setPaused] = useState(false);
  return (
    <section className="qi-tools" aria-label="เครื่องมือที่เราใช้">
      <div className="qi-tools-inner">
        <div className="tools-heading"><div><p className="studio-eyebrow">เครื่องมือที่ทีมคุณใช้</p><h2 className="qi-tools-title">เราใช้เครื่องมือที่คุณมีอยู่แล้ว</h2></div>
        <p className="qi-tools-lead">เริ่มจากระบบที่ทีมคุณใช้อยู่ เราตรวจตัวเลือกการเชื่อมต่อ สิทธิ์เข้าถึง และข้อจำกัดของแพ็กเกจ ก่อนแนะนำวิธีเชื่อมระบบ</p></div>
        <div className="tools-ribbon-controls"><button type="button" className="motion-toggle" aria-pressed={paused} onClick={() => setPaused(!paused)}><span aria-hidden="true">{paused ? '▷' : 'Ⅱ'}</span> {paused ? 'เล่นแถบเครื่องมือ' : 'หยุดแถบเครื่องมือ'}</button></div>
      </div>
      <MotionScene className="tools-ribbon" paused={paused} label="ดูเครื่องมือธุรกิจ">
        <div className="tools-track">{[false, true].map(duplicate => <ul key={String(duplicate)} aria-label={duplicate ? undefined : 'เครื่องมือธุรกิจ'} aria-hidden={duplicate || undefined}>{BUSINESS.map(tool => <li key={tool.name} className="qi-logo-cell"><img src={tool.src} alt="" width={34} height={34} loading="lazy" /><span>{tool.name}</span></li>)}</ul>)}</div>
      </MotionScene>
      <div className="qi-tools-inner tools-footnote">
        <p className="qi-tools-secondary">เครื่องมือที่แสดงเป็นตัวอย่าง ไม่ใช่การประกาศเป็นพันธมิตรหรือการรับรอง การเชื่อมต่อขึ้นอยู่กับ API และสิทธิ์ของบัญชี</p>
        <div className="tools-platforms"><span>เชื่อมต่อด้วย</span><ul className="qi-logo-row" aria-label="แพลตฟอร์มระบบอัตโนมัติ">{AUTOMATION.map(tool => <li key={tool.name} className="qi-logo-cell-sm"><img src={tool.src} alt="" width={22} height={22} loading="lazy" /><span>{tool.name}</span></li>)}</ul></div>
      </div>
      <aside className="qi-invite">
        <img className="qi-invite-photo" src={`${base}photos/pexels-8374279.jpg`} alt="" aria-hidden="true" loading="lazy" />
        <div className="qi-invite-copy"><h3>บอกเราว่างานติดขัดตรงไหน</h3><p>เล่างานและเครื่องมือที่คุณใช้ เราจะช่วยกำหนดว่าเวอร์ชันแรกต้องทำอะไรบ้าง</p><Link className="qi-invite-link" to="/th/#request-demo">ขอดูเดโม ↗</Link></div>
      </aside>
    </section>
  );
};
export default ToolsStrip;
